"use strict";

var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reactIntlNumberFormats = exports.NumberFormat = void 0;
var NumberFormat;
(function (NumberFormat) {
  NumberFormat["SHORT_FORMAT"] = "0.[00]a";
  NumberFormat["PERCENTAGE_FORMAT"] = "0.[00]%";
  NumberFormat["ROUND_PERCENTAGE_FORMAT"] = "0%";
})(NumberFormat = exports.NumberFormat || (exports.NumberFormat = {}));
exports.reactIntlNumberFormats = (_a = {}, _a[NumberFormat.SHORT_FORMAT] = {
  maximumFractionDigits: 2
}, _a[NumberFormat.PERCENTAGE_FORMAT] = {
  maximumFractionDigits: 2,
  style: 'percent'
}, _a[NumberFormat.ROUND_PERCENTAGE_FORMAT] = {
  maximumFractionDigits: 0,
  style: 'percent'
}, _a);